import React from 'react';
import css from './icon.module.css'
import { AiFillInstagram } from "react-icons/ai";

export const instagramIcon = ({ ariaLabel = 'Instagram' }) => {
  return (
    <AiFillInstagram className={css.icon}/>
  );
};